export default __webpack_public_path__ + "static/media/Spice.5ffa07b6.svg";